/**
 * ============================================================
 * Aladdin Fitness - Custom Checkout
 * Shopify + Cloudflare Worker
 * Version 2.0
 * ============================================================
 */

"use strict";

/*==============================================================
CONFIG
==============================================================*/

const CONFIG = {

    WORKER_URL: "https://shopify-order-api.ali-samy.workers.dev",

    SHIPPING_PRICE: 300000,          // 3000 IQD (Shopify x100)

    FREE_SHIPPING_LIMIT: 9500000     // 95000 IQD

};

/*==============================================================
GLOBAL STATE
==============================================================*/

let cartData = null;

let cartEventsAttached = false;

/*==============================================================
FORMAT MONEY
==============================================================*/

function formatMoney(value){

    return Math.round(value / 100).toLocaleString("ar-IQ") + " د.ع";

}

/*==============================================================
LOAD CART
==============================================================*/

async function loadCart(){

    try{

        const response = await fetch("/cart.js");

        if(!response.ok){

            throw new Error("Cannot load cart.");

        }

        cartData = await response.json();

        console.log("Cart:", cartData);

        renderCart(cartData);

        renderSummary(cartData);

    }

    catch(error){

        console.error(error);

        showCartError();

    }

}

/*==============================================================
SHOW ERROR
==============================================================*/

function showCartError(){

    const container=document.getElementById("checkout-cart");

    if(!container) return;

    container.innerHTML=`

        <div class="checkout-error">

            <p>حدث خطأ أثناء تحميل السلة.</p>

            <button class="checkout-btn checkout-btn--secondary"

                    onclick="location.reload()">

                إعادة المحاولة

            </button>

        </div>

    `;

}

/*==============================================================
RENDER CART
==============================================================*/

function renderCart(cart){

    const container=document.getElementById("checkout-cart");

    if(!container) return;

    if(!cart.items.length){

        container.innerHTML=`

        <div class="checkout-empty">

            <p>السلة فارغة.</p>

            <a href="/collections/all"

               class="checkout-btn checkout-btn--secondary">

               متابعة التسوق

            </a>

        </div>

        `;

        return;

    }

    let html='<div class="checkout-items-list">';

    cart.items.forEach(item=>{

        html+=`

<div class="cart-item" data-key="${item.key}">

<div class="cart-item__image-wrap">

<img

src="${item.image}"

class="cart-item__image"

loading="lazy"

width="90"

height="90"

>

</div>

<div class="cart-item__details">

<div class="cart-item__title">

${item.product_title}

</div>

${
item.variant_title &&
item.variant_title!="Default Title"

?

`<div class="cart-item__variant">

${item.variant_title}

</div>`

:

""

}

<div class="cart-item__price">

${formatMoney(item.final_line_price)}

</div>

</div>

<div class="cart-item__controls">

<div class="cart-item__qty">

<button

class="qty-btn"

data-action="decrease"

data-key="${item.key}"

>

−

</button>

<span class="qty-value">

${item.quantity}

</span>

<button

class="qty-btn"

data-action="increase"

data-key="${item.key}"

>

+

</button>

</div>

<button

class="cart-item__remove"

data-action="remove"

data-key="${item.key}"

>

حذف

</button>

</div>

</div>

`;

    });

    html+="</div>";

    container.innerHTML=html;

    attachCartControls();

}

/*==============================================================
RENDER SUMMARY
==============================================================*/

function renderSummary(cart){

    const container=document.getElementById("checkout-summary");

    if(!container) return;

    const subtotal=cart.total_price;

    const discount=cart.total_discount;

    const shipping=

    subtotal>=CONFIG.FREE_SHIPPING_LIMIT

    ?

    0

    :

    CONFIG.SHIPPING_PRICE;

    const total=subtotal+shipping;

    let freeShippingHTML="";

    if(shipping===0){

        freeShippingHTML=`

        <div class="summary-free-shipping-msg">

        ✅ حصلت على شحن مجاني

        </div>

        `;

    }

    else{

        const remain=

        CONFIG.FREE_SHIPPING_LIMIT-subtotal;

        const progress=

        Math.min(

        subtotal/

        CONFIG.FREE_SHIPPING_LIMIT*100,

        100

        );

        freeShippingHTML=`

<div class="summary-shipping-progress">

<div class="summary-shipping-bar">

<div

class="summary-shipping-fill"

style="width:${progress}%"

></div>

</div>

<div class="summary-shipping-hint">

تبقى

<strong>

${formatMoney(remain)}

</strong>

للشحن المجاني

</div>

</div>

`;

    }

    container.innerHTML=`

<div class="summary-row">

<span>

عدد المنتجات

</span>

<span>

${cart.item_count}

</span>

</div>

<div class="summary-row">

<span>

المجموع

</span>

<span>

${formatMoney(subtotal)}

</span>

</div>

${
discount>0

?

`

<div class="summary-row summary-row--discount">

<span>

الخصم

</span>

<span>

-${formatMoney(discount)}

</span>

</div>

`

:

""

}

<div class="summary-row">

<span>

الشحن

</span>

<span>

${
shipping===0

?

"مجاني"

:

formatMoney(shipping)

}

</span>

</div>

${freeShippingHTML}

<div class="summary-total">

<span>

الإجمالي

</span>

<strong>

${formatMoney(total)}

</strong>

</div>

`;

}

/*==============================================================
UPDATE CART
==============================================================*/

async function updateCartItem(key, quantity) {

    try {

        const response = await fetch("/cart/change.js", {

            method: "POST",

            headers: {
                "Content-Type": "application/json"
            },

            body: JSON.stringify({

                id: key,

                quantity: quantity

            })

        });

        if (!response.ok) {

            throw new Error("Cart update failed");

        }

        cartData = await response.json();

        renderCart(cartData);

        renderSummary(cartData);

    }

    catch (error) {

        console.error(error);

        alert("حدث خطأ أثناء تحديث السلة.");

    }

}

/*==============================================================
ATTACH CART EVENTS
==============================================================*/

function attachCartControls() {

    if (cartEventsAttached) return;

    cartEventsAttached = true;

    document.addEventListener("click", async function (event) {

        const button = event.target.closest("[data-action]");

        if (!button) return;

        const action = button.dataset.action;

        const key = button.dataset.key;

        if (!key) return;

        const item = cartData.items.find(i => i.key === key);

        if (!item) return;

        button.disabled = true;

        try {

            switch (action) {

                case "increase":

                    await updateCartItem(

                        key,

                        item.quantity + 1

                    );

                    break;

                case "decrease":

                    if (item.quantity > 1) {

                        await updateCartItem(

                            key,

                            item.quantity - 1

                        );

                    }

                    break;

                case "remove":

                    if (confirm("هل تريد حذف هذا المنتج؟")) {

                        await updateCartItem(

                            key,

                            0

                        );

                    }

                    break;

            }

        }

        finally {

            button.disabled = false;

        }

    });

}

/*==============================================================
REFRESH CART
==============================================================*/

async function refreshCart() {

    try {

        const response = await fetch("/cart.js");

        if (!response.ok) {

            throw new Error("Refresh failed");

        }

        cartData = await response.json();

        renderCart(cartData);

        renderSummary(cartData);

    }

    catch (error) {

        console.error(error);

    }

}

/*==============================================================
WATCH CART CHANGES
==============================================================*/

window.addEventListener("pageshow", function () {

    refreshCart();

});

document.addEventListener("visibilitychange", function () {

    if (!document.hidden) {

        refreshCart();

    }

});

/*==============================================================
HELPERS
==============================================================*/

function getShippingPrice(subtotal) {

    return subtotal >= CONFIG.FREE_SHIPPING_LIMIT

        ? 0

        : CONFIG.SHIPPING_PRICE;

}

function getGrandTotal(cart) {

    return cart.total_price +

        getShippingPrice(cart.total_price);

}

/*==============================================================
FIELD VALIDATION
==============================================================*/

function showFieldError(id, message) {

    const input = document.getElementById(id);

    const error = document.getElementById(id + "-error");

    if (input) input.classList.add("field__input--error");

    if (error) error.textContent = message;

}

function clearFieldError(id) {

    const input = document.getElementById(id);

    const error = document.getElementById(id + "-error");

    if (input) input.classList.remove("field__input--error");

    if (error) error.textContent = "";

}

/*==============================================================
ORDER FORM
==============================================================*/

function setupOrderForm() {

    const form = document.getElementById("custom-checkout-form");

    if (!form) return;

    form.addEventListener("submit", submitOrder);

}

/*==============================================================
SUBMIT ORDER
==============================================================*/

async function submitOrder(event) {

    event.preventDefault();

    const name = document.getElementById("customer-name").value.trim();

    const phone = document.getElementById("customer-phone").value.trim();

    const city = document.getElementById("customer-city").value.trim();

    const address = document.getElementById("customer-address").value.trim();

    const note = document.getElementById("customer-note").value.trim();

    clearFieldError("customer-name");
    clearFieldError("customer-phone");
    clearFieldError("customer-city");
    clearFieldError("customer-address");

    let valid = true;

    if (!name) {

        showFieldError("customer-name", "يرجى إدخال الاسم");

        valid = false;

    }

    if (!phone) {

        showFieldError("customer-phone", "يرجى إدخال الهاتف");

        valid = false;

    }

    if (!city) {

    showFieldError("customer-city", "يرجى اختيار المحافظة");

    valid = false;
    }

    if (!address) {

        showFieldError("customer-address", "يرجى إدخال العنوان");

        valid = false;

    }

    if (!valid) return;

    await refreshCart();

    if (!cartData || cartData.item_count === 0) {

        alert("السلة فارغة.");

        return;

    }

    const button = document.getElementById("submit-order");

    button.disabled = true;

    button.innerHTML = "جاري إرسال الطلب...";

    const shipping = getShippingPrice(cartData.total_price);

    const payload = {

        customer: {

            name,

            phone,

            city,

            address,

            note

        },

        cart: {

            token: cartData.token,

            currency: cartData.currency,

            subtotal: cartData.total_price,

            discount: cartData.total_discount,

            shipping: shipping,

            grand_total: getGrandTotal(cartData),

            item_count: cartData.item_count,

            created_at: Date.now()

        },

        items: cartData.items.map(item => ({

            variant_id: item.variant_id,

            quantity: item.quantity,

            title: item.product_title,

            variant_title: item.variant_title,

            sku: item.sku,

            original_price: item.original_price,

            final_price: item.final_price,

            line_price: item.final_line_price

        }))

    };

    console.log("Sending Order", payload);

    try {

        const response = await fetch(CONFIG.WORKER_URL, {

            method: "POST",

            headers: {

                "Content-Type": "application/json"

            },

            body: JSON.stringify(payload)

        });

        const result = await response.json();

        console.log(result);

        if (!response.ok || !result.success) {

            throw new Error(

                result.error ||

                result.message ||

                "Unknown Error"

            );

        }

        await fetch("/cart/clear.js", {

            method: "POST"

        });

        if (result.redirect_url) {

            window.location.href = result.redirect_url;

        }

        else {

            window.location.href = "/pages/thank-you";

        }

    }

    catch (error) {

        console.error(error);

        alert(error.message);

        button.disabled = false;

        button.innerHTML = "تأكيد الطلب — الدفع عند الاستلام";

    }

}

/*==============================================================
INITIALIZE
==============================================================*/

function initCheckout() {

    loadCart();

    setupOrderForm();

}

document.addEventListener(

    "DOMContentLoaded",

    initCheckout

);